/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Coverage quality for a report response.
 */
export enum ReportCoverageMode {
    EXACT = 'exact',
    MIXED = 'mixed',
    APPROXIMATE = 'approximate',
}
